import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { apiPaths } from '../../../../../service/apiPaths';
import ApiService from '../../../../../service/ApiService';
import { ILeaveRequest } from '../../Leave.props';

const useEditLeaveRequest = (leaveId: string, setMethod: () => void) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<ILeaveRequest>({
    description: "",
    fromDate: "",
    toDate: "",
    type: "single",
    subtype: "full",
  });

  useEffect(() => {
    fetchLeaveRequest();
  }, [leaveId]);

  const fetchLeaveRequest = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getLeave}?id=${leaveId}`,
      });

      // Format dates to YYYY-MM-DD format
      const formattedData = {
        ...response.leaves[0],
        fromDate: response.leaves[0].fromDate
          ? new Date(response.leaves[0].fromDate).toISOString().split("T")[0]
          : "",
        toDate: response.leaves[0].toDate
          ? new Date(response.leaves[0].toDate).toISOString().split("T")[0]
          : "",
      };

      setFormData(formattedData);
    } catch (error) {
      toast.error("Failed to fetch leave request details");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newData = { ...prev, [name]: value };
      if (name === "fromDate" && prev.type === "single") {
        newData.toDate = value;
      }
      return newData;
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateLeaveRequest}${leaveId}`,
        data: formData,
      });
      toast.success("Leave request updated successfully");
      setMethod();
    } catch (error) {
      toast.error("Failed to update leave request");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    formData,
    handleChange,
    handleSubmit,
    handleDateChange,
  };
};

export default useEditLeaveRequest;
